module.exports = __webpack_public_path__ + "static/media/team.cfeacc42.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/team.png
// module id = 243
// module chunks = 0